import React from 'react'
import Header from './components/Header';
import Footer from './components/Footer';
import { useState,useEffect } from 'react';
import './styles/motoStyles.css';
import lotus from '../src/images/lotus.png';

const Will = () => {
  const [fadeOut, setFadeOut] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setFadeOut(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

    
    useEffect(() => {
      const handleScroll = () => {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (scrollTop > 50) {
          setScrolled(true);
        } else {
          setScrolled(false);
        }
      };
    
      window.addEventListener("scroll", handleScroll);
      handleScroll();
    
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    }, []);
  return (
    <div>
      <div className={`moto ${fadeOut ? 'fade-out' : ''}`}>
        <h1>Family Matters, Will & Succession here at KWA</h1>
      </div>
      <Header scrolled={scrolled}/>
      <div className='justify-content-center d-flex align-items-center w-100 fs-4' style={{minHeight:'100vh',padding:'10%',paddingTop: '5%',paddingBottom: '5%'}}>
        <img src={lotus} alt='' className='lotus'></img>
        <div className=''><p>Welcome to <span className="kwa">KWA</span>, where we specialize in matters concerning <span className="highlight">family law</span>, <span className="highlight">will</span>, and <span className="highlight">succession</span> in accordance with <span className="highlight">Indian legal statutes</span>. With an unwavering commitment to serving our clients with utmost professionalism and integrity, we understand the intricacies and sensitivities involved in navigating familial and succession matters.</p>
        <br />
        <p>Our expertise in <span className="highlight">family law</span> encompasses a wide array of issues including <span className="highlight">divorce</span>, <span className="highlight">child custody</span>, <span className="highlight">adoption</span>, and <span className="highlight">domestic violence</span>, among others. We recognize the importance of resolving these matters with compassion and efficiency, always prioritizing the well-being of our clients and their loved ones.</p>
        <br />
        <p>In the realm of <span className="highlight">will and succession</span>, we provide comprehensive legal assistance to ensure that our clients' intentions are accurately reflected, and their assets are distributed in accordance with their wishes. From <span className="highlight">drafting will</span> to navigating the complexities of <span className="highlight">probate</span> and <span className="highlight">estate administration</span>, our experienced attorneys guide clients through every step of the process with diligence and expertise.</p>
        <br />
        <p>At <span className="kwa">KWA</span>, we take pride in our deep understanding of Indian laws governing <span className="highlight">family matters</span>, <span className="highlight">will</span>, and <span className="highlight">succession</span>. Our team of skilled attorneys combines legal acumen with a client-cantered approach to deliver tailored solutions that meet the unique needs of each individual or family we serve.</p>
        <br />
        <p>Trust <span className="kwa">KWA</span> to provide you with the expert legal representation you deserve in all aspects of <span className="highlight">family law</span>, <span className="highlight">will</span>, and <span className="highlight">succession matters</span>. Contact us today to schedule a consultation and let us help you navigate the legal complexities with confidence and peace of mind.</p></div>
      </div>
      <Footer />
    </div>
  )
}

export default Will
